import React from "react"
import { Modal } from "react-bootstrap"
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux"
import { IModalWarning } from "./interface"
import Button from "../Button"
import color from "../../assets/css/colors"

const ModalWarning = (props: IModalWarning) => {
    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();
    
    return (
        <>
            {
                login.user.branchs.standardLogo === null 
                ? <Modal show={true}
                    backdrop="static"
                    keyboard={false}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Modal.Title>{ props.title }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        { props. description }
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex">
                            <Button style={{background: `${color.grayDark}`, boxShadow: "none"}}  onClick={() => history.push(props.pathBack)}>
                                Voltar
                            </Button>
                            <Button style={{marginLeft: 20, width: 150}} onClick={() => history.push(props.pathGo)} >Ir</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
                : null
            }
        </>
    )
}

export default ModalWarning